var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _g, _rect5, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78 388H396V406H78V388Z",
    fill: "url(#paint0_linear_106_771)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M297 296H396V314H297V296Z",
    fill: "url(#paint1_linear_106_771)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297 213H396V231H297V213Z",
    fill: "url(#paint2_linear_106_771)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M297 254H396V272H297V254Z",
    fill: "url(#paint3_linear_106_771)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78 443H396V461H78V443Z",
    fill: "url(#paint4_linear_106_771)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#0E85CD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.179 76.0909C106.179 83.6136 104.77 90.0568 101.952 95.4205C99.1563 100.761 95.3381 104.852 90.4972 107.693C85.679 110.534 80.2131 111.955 74.0994 111.955C67.9858 111.955 62.5085 110.534 57.6676 107.693C52.8494 104.83 49.0313 100.727 46.2131 95.3864C43.4176 90.0227 42.0199 83.5909 42.0199 76.0909C42.0199 68.5682 43.4176 62.1364 46.2131 56.7955C49.0313 51.4318 52.8494 47.3295 57.6676 44.4886C62.5085 41.6477 67.9858 40.2273 74.0994 40.2273C80.2131 40.2273 85.679 41.6477 90.4972 44.4886C95.3381 47.3295 99.1563 51.4318 101.952 56.7955C104.77 62.1364 106.179 68.5682 106.179 76.0909ZM93.4631 76.0909C93.4631 70.7955 92.6335 66.3295 90.9744 62.6932C89.3381 59.0341 87.0653 56.2727 84.1562 54.4091C81.2472 52.5227 77.8949 51.5795 74.0994 51.5795C70.304 51.5795 66.9517 52.5227 64.0426 54.4091C61.1335 56.2727 58.8494 59.0341 57.1903 62.6932C55.554 66.3295 54.7358 70.7955 54.7358 76.0909C54.7358 81.3864 55.554 85.8636 57.1903 89.5227C58.8494 93.1591 61.1335 95.9205 64.0426 97.8068C66.9517 99.6705 70.304 100.602 74.0994 100.602C77.8949 100.602 81.2472 99.6705 84.1562 97.8068C87.0653 95.9205 89.3381 93.1591 90.9744 89.5227C92.6335 85.8636 93.4631 81.3864 93.4631 76.0909ZM141.795 111H118.136V41.1818H142.273C149.205 41.1818 155.159 42.5795 160.136 45.375C165.136 48.1477 168.977 52.1364 171.659 57.3409C174.341 62.5455 175.682 68.7727 175.682 76.0227C175.682 83.2955 174.33 89.5455 171.625 94.7727C168.943 100 165.068 104.011 160 106.807C154.955 109.602 148.886 111 141.795 111ZM130.784 100.057H141.182C146.045 100.057 150.102 99.1705 153.352 97.3977C156.602 95.6023 159.045 92.9318 160.682 89.3864C162.318 85.8182 163.136 81.3636 163.136 76.0227C163.136 70.6818 162.318 66.25 160.682 62.7273C159.045 59.1818 156.625 56.5341 153.42 54.7841C150.239 53.0114 146.284 52.125 141.557 52.125H130.784V100.057ZM181.537 51.7841V41.1818H237.241V51.7841H215.662V111H203.116V51.7841H181.537Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 171,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#0E85CD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.507 227.743C233.165 227.56 232.812 227.395 232.473 227.224C226.921 224.585 220.809 222.846 214.314 222.237C202.842 221.167 191.87 223.769 182.605 229.071C176.263 225.516 169.068 223.198 161.334 222.474C150.671 221.476 140.454 223.663 131.615 228.232C131.53 228.271 131.442 228.326 131.356 228.374C131.146 228.536 131 228.792 131 229.082C131 229.582 131.405 229.989 131.913 229.989C131.966 229.989 132.016 229.977 132.063 229.977C132.084 229.968 132.106 229.968 132.125 229.968C136.873 229.096 141.832 228.848 146.88 229.321C161.049 230.647 173.393 234.956 182.06 244.667C182.51 245.126 182.911 245.104 183.368 244.643C194.27 232.165 210.978 227.24 228.936 228.912C229.934 229.007 230.927 229.13 231.905 229.283C232.246 229.328 232.773 229.413 233.081 229.444C233.675 229.514 234 229.043 234 228.544C233.999 228.197 233.847 227.91 233.507 227.743V227.743Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.861 315.656C142.096 315.872 142.405 316 142.753 316C143.177 316 143.56 315.802 143.806 315.494C143.812 315.494 144.34 314.755 144.608 314.393C161.442 291.509 189.198 280.228 220.09 280.228C222.292 280.228 224.495 280.31 226.661 280.464C227.287 280.505 228.597 280.606 228.626 280.606C229.386 280.606 230 279.995 230 279.246C230 278.704 229.684 278.245 229.233 278.025C229.176 278.002 229.122 277.979 229.066 277.958C218.188 273.476 206.253 271 193.739 271C173.751 271 155.241 277.305 140.116 288.024C128.568 282.868 115.771 280.003 102.294 280.003C93.8855 280.003 85.741 281.122 78 283.214C78.7949 287.005 79.8496 290.7 81.1208 294.293C104.736 294.705 125.774 300.617 141.745 315.55C141.778 315.59 141.818 315.63 141.861 315.656V315.656Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_771",
    x: 30.0195,
    y: 40.2266,
    width: 211.223,
    height: 87.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_771"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_771",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_771",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E85CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F669B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_771",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E85CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F669B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_771",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E85CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F669B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_771",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E85CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F669B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_771",
    x1: 237,
    y1: 213,
    x2: 237,
    y2: 461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E85CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F669B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOdt);
export default __webpack_public_path__ + "static/media/odt.aac006b59a75a5c4794e9a30cc510a4b.svg";
export { ForwardRef as ReactComponent };